import { useQueryClient } from 'react-query';
import { SCENE_QUERY_KEYS } from '../../../domains/scene/ui/queryKeys';

export const useInvalidateSceneCommentQueries = () => {
  const queryClient = useQueryClient();

  const invalidateReplies = (adaptedFictionEditionId: string, commentId: string) =>
    queryClient.invalidateQueries(
      SCENE_QUERY_KEYS.adaptedFictionEditionReplies(adaptedFictionEditionId, commentId)
    );

  const invalidateCommentDetail = (adaptedFictionEditionId: string, commentId: string) =>
    queryClient.invalidateQueries(
      SCENE_QUERY_KEYS.sceneCommentDetail(adaptedFictionEditionId, commentId)
    );

  const invalidateRepliesAndDetail = (adaptedFictionEditionId: string, commentId: string) =>
    Promise.all([
      invalidateReplies(adaptedFictionEditionId, commentId),
      invalidateCommentDetail(adaptedFictionEditionId, commentId)
    ]);

  return {
    invalidateReplies,
    invalidateCommentDetail,
    invalidateRepliesAndDetail
  };
};
